import React from 'react'

import {
  LaTercera,
  Pulso,
  LaTerceraPM,
  Culto,
  QuePasa,
  Paula,
  CronicaEstereo,
  LaTerceraNoche,
  PulsoPM,
  InvestigacionyDatos,
  LaTerceraSabado,
  LaTerceraDomingo,
  ElDeportivo,
} from '@labcon/copesa-logos'

const data = [
  {
    slug: 'la-tercera',
    logo: LaTercera,
    title: 'La Tercera',
    description: 'Noticias y actualidad de Chile y el mundo.',
  },
  {
    slug: 'la-tercera-pm',
    logo: LaTerceraPM,
    title: 'La Tercera PM',
    description:
      'Edición especial —de lunes a viernes— con golpes noticiosos, análisis y comentarios a los temas que marcan la jornada.',
  },
  {
    slug: 'la-tercera-noche',
    logo: LaTerceraNoche,
    title: 'La Tercera Noche',
    description: '',
  },
  {
    slug: 'la-tercera-sabado',
    logo: LaTerceraSabado,
    title: 'La Tercera Sabado',
    description: '',
  },
  {
    slug: 'la-tercera-domingo',
    logo: LaTerceraDomingo,
    title: 'La Tercera Domingo',
    description: '',
  },
  {
    slug: 'pulso',
    logo: Pulso,
    title: 'Pulso',
    description:
      'El brazo de negocios de La Tercera, enfocado en empresas y mercados.',
  },
  {
    slug: 'pulso-pm',
    logo: PulsoPM,
    title: 'Pulso PM',
    description: '',
  },
  {
    slug: 'investigacion-y-datos',
    logo: InvestigacionyDatos,
    title: 'Investigación y Datos',
    description: '',
  },
  {
    slug: 'culto',
    logo: Culto,
    title: 'Culto',
    description:
      'Entretención y cultura, con lo más destacado en series, música, literatura y cine.',
  },
  {
    slug: 'paula',
    logo: Paula,
    title: 'Paula',
    description: 'La voz de la mujer de hoy.',
  },
  {
    slug: 'que-pasa',
    logo: QuePasa,
    title: 'Qué Pasa',
    description:
      'Preguntas que mueven al mundo. Ciencia, medio ambiente y sociedad.',
  },
  {
    slug: 'cronica-estereo',
    logo: CronicaEstereo,
    title: 'Crónica Estéreo',
    description:
      'Cada historia tiene un sonido. El nuevo podcast de La Tercera que profundiza y pone en contexto las historias detrás de las noticias a través de la narración sonora.',
  },
  {
    slug: 'el-deportivo',
    logo: ElDeportivo,
    title: 'El Deportivo',
    description:
      'Toda la actualidad sobre Deportes en Chile y el mundo, con noticias y profundidad.',
  },
]

export default data
